import { View } from 'react-native'
import Icon from '@ui/elements/Icon'
import Typography from '@ui/typography'
import { colors } from '@ui/colors'

type ContactType = 'email' | 'phone' | 'address'

interface Props {
  data: string | null | undefined
  state?: boolean
  type: ContactType
}

export default function UserContactState({ data, type, state }: Props) {
  if (!data) return null

  const color = (() => {
    if (type === 'address') return colors.black50
    if (state) return colors.green[600]
    return colors.neutral[300]
  })()

  const iconSize = 16

  return (
    <View className="flex-1 flex-row items-center justify-between gap-8 px-8">
      <View className="flex h-8 w-8 items-center justify-center">
        {type === 'email' && (
          <Icon
            name={state ? 'email-filled' : 'mail'}
            size={iconSize}
            color={color}
          />
        )}
        {type === 'phone' && (
          <Icon
            name={state ? 'phone-filled' : 'phone'}
            size={iconSize}
            color={color}
          />
        )}
        {type === 'address' && (
          <Icon name="home-filled" size={iconSize} color={color} />
        )}
      </View>
      <Typography
        variant="SM"
        className={'flex-1 font-text-semibold'}
        style={{ color }}
        numberOfLines={1}
      >
        {data}
      </Typography>
    </View>
  )
}
